import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.333 11.5 17 13.167v1.666h-4.167v5l-.833.834-.833-.834v-5H7v-1.666L8.667 11.5V5.667h-.834V4h8.334v1.667h-.834V11.5Z",
		fill: "currentColor"
	})
});
export default SvgPin;
